export default {
  historicalData: 'Historical data',
  simulated: 'Simulated',
  historical: 'Historical',
  budget: 'Budget',
  attributedSales: 'Marketing-attributed',
  weekEnding: 'Week ending {date}'
}
